import styled from "styled-components";

export const UserMenuClosePCButtonBox = styled.div`
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
`;
